import { RoutePath } from "@/lib/routes"

export const telesalesRoutesPaths = {
    root: RoutePath.create("/v2/televente"),
    index: RoutePath.create("/v2/televente/:joinSupplierProcessNumber"),
    prePayment: RoutePath.create("/v2/televente/informations-de-paiement/premiere-mensualite"),
    paymentDetails: RoutePath.create(
        "/v2/televente/informations-de-paiement?token=:token&quoteCode=:quoteCode"
    ),
    paymentDetailsFinancialSituation: RoutePath.create(
        "/v2/televente/informations-de-paiement/situation-financiere"
    ),
    paymentDetailsRetry: RoutePath.create("/v2/televente/informations-de-paiement/erreur"),
    paymentDetailsUnpaidBills: RoutePath.create(
        "/v2/televente/informations-de-paiement/erreur-paiement"
    ),
    paymentDetailsErrorIban: RoutePath.create(
        "/v2/televente/informations-de-paiement/erreur-paiement-cn"
    ),
    paymentDetailsErrorSignature: RoutePath.create(
        "/v2/televente/informations-de-paiement/erreur-signature"
    ),
    paymentDetailsErrorPrepayment: RoutePath.create(
        "/v2/televente/informations-de-paiement/erreur-prepaiement"
    ),
    paymentDetailsPendingPrepayment: RoutePath.create(
        "/v2/televente/informations-de-paiement/attente-confirmation-paiement"
    ),
    securityDeposit: RoutePath.create("/v2/televente/depot-de-garantie"),
    orderReview: RoutePath.create("/v2/televente/resume-de-commande"),
    onboarded: RoutePath.create("/v2/televente/bienvenue"),
} as const
